// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const sidebarConfig = [
  // {
  //   title: 'home',
  //   path: '/app/home',
  //   icon: getIcon('ant-design:home-filled'),
  // },
  // {
  //   title: 'chat',
  //   path: '/app/chat',
  //   icon: getIcon('entypo:chat'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon('eva:lock-fill'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: getIcon('eva:alert-triangle-fill'),
  // },
];

export default sidebarConfig;
